import { type GenericFilterOption, type FilterDefinition } from '../../../../../filters';
import { type FilterOption } from '../../../../../../common/filters/types';
import {
	type FiltersInfo,
	type FiltersForAnalytics,
} from '../../../../../../common/analytics/events';

export function transformAvailableFiltersForAnalytics<T extends FilterOption>(
	availableFilters: T[],
): FiltersInfo {
	const appliedFilters = availableFilters
		.map((availableFilter: T, index) => ({
			...availableFilter,
			index,
		}))
		.filter((filterWithIndex) => filterWithIndex.isChecked);
	return {
		applied: appliedFilters.map((appliedFilter) => ({
			id: appliedFilter.id,
			source: appliedFilter.filterSource,
			index: appliedFilter.index,
		})),
		recommendedIds: availableFilters.map((appliedFilter: T) => ({
			id: appliedFilter.id,
			source: appliedFilter.filterSource,
		})),
	};
}

export const transformFiltersForAnalytics = (
	filters: FilterDefinition<GenericFilterOption>[],
): FiltersForAnalytics => {
	let filtersForAnalytics = {};
	filters.map((filter) => {
		filtersForAnalytics = {
			...filtersForAnalytics,
			[filter['@type']]: transformAvailableFiltersForAnalytics(filter.store.availableFilters),
		};
	});
	return filtersForAnalytics;
};
